import { useMutation } from '@tanstack/react-query';
import { postMerchantOverridesBulkUploadErrorCSV } from 'Services';
import { useTranslation } from 'react-i18next';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';

function useCreateMerchantOverridesBulkUploadErrorCSV(errors: UploadErrorsType, filename: string) {
    const { t } = useTranslation();
    const { addTechnicalErrorModal } = useReduxModal();

    const values = {
        filename,
        errors
    };
    return useMutation([values], () => postMerchantOverridesBulkUploadErrorCSV(values), {
        onSuccess: (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `${filename}.csv`;
            document.body.appendChild(link);
            link.click();
        },
        onError: () => {
            addTechnicalErrorModal(t('Failed to export CSV.'), t('Unable to export CSV'));
        }
    });
}

export default useCreateMerchantOverridesBulkUploadErrorCSV;
